import type { CopilotResourceRef } from "src/clients/agent-management";
import { ContextualEntityChip } from "src/unifiedCopilot/chat/ContextualEntityChip";
import { useResourceMentionClick } from "src/unifiedCopilot/chat/useResourceMentionClick";

/**
 * Opens the results of a run the copilot started, from the run's own card.
 *
 * The same deeplink a `testrun` mention follows, so the two cannot land
 * anywhere different.
 */
export const TestRunResultsLink: React.FC<{
  testRunId: string;
  flowVersionId: string | null;
}> = ({ testRunId, flowVersionId }) => {
  const ref: CopilotResourceRef = {
    type: "testrun",
    id: testRunId,
    ...(flowVersionId && {
      parent: { type: "flow-version", id: flowVersionId },
    }),
  };
  const onClick = useResourceMentionClick(ref);

  // The card also renders outside a workspace route, where nothing could be
  // navigated to.
  if (!onClick) {
    return null;
  }
  return (
    <ContextualEntityChip
      dataLoc={`test-run-results-${testRunId}`}
      entity={{ displayName: "Open results", type: "testrun" }}
      onClick={onClick}
    />
  );
};
